import { render, staticRenderFns } from "./RoomStatusDetailDialog.vue?vue&type=template&id=95db6180&scoped=true"
import script from "./RoomStatusDetailDialog.vue?vue&type=script&lang=js"
export * from "./RoomStatusDetailDialog.vue?vue&type=script&lang=js"
import style1 from "./RoomStatusDetailDialog.vue?vue&type=style&index=1&id=95db6180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95db6180",
  null
  
)

export default component.exports